const login = (returnUrl?: string) => {
    const controllerUrl = `/auth/login${returnUrl ? `?returnUrl=${returnUrl}` : ""}`;
    document.location.href = document.location.origin + controllerUrl;
};

const authService = { login };
export default authService;
